<template>
    <div>
        <div name="query-sort-block" class="mt10">
            <swb-query-sort-area ref="query_model_ctrl" class="mb10" :confKey="confKey" :configAuto="true" :queryOnLoad="true" :onConfigReady="onQueryConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <div name="btns" class="simple-row clearfix" v-if="checkActionPerm('create')">
            <div class="left">
                <div class="swb-btn swb-btn-small" @click="saveDdctQrcode()">新增</div>
            </div>
        </div>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight" :pageNoChangeHandler="pageNoChangeHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utilsx, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher, showQrCodeImageDlg } from '../../app.vues'

    import { getDefaultPageSizes } from '../../app.conf'
    import { checkUserActionPerm } from '../index'

    import merchtComnApi from '../../api/merchtComn'
    import retailerAuthxApi from '../../api/retailerAuthx'
    //
    import SwbDdctQrcodeSave from './DdctQrcodeSave';
    Vue.regist(SwbDdctQrcodeSave);

    export default {
        name: 'swb-ddct-qrcode-list',
        path: '/ddct/qrcode/list',
        desc: '专用二维码管理列表',
        data: function () {
            return {
                // 分页信息
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                lastPageNumber: null,
                //
                confKey: 'swb-ddct-qrcode-list',
                theTableHeight: 150,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）d
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                //
                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 200,//操作列宽度（默认：100）
                btnColFixed: true, //操作列是否固定
                // 过滤信息
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.theTableHeight = height;
            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('[name="query-sort-block"], [name="btns"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            onQueryConfigReady: function () {
                //
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'usage': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.usage == 1) {
                            return '<span>入职</span>';
                        } else if(row.usage == 2) {
                            return '<span>离职</span>';
                        }
                    },
                    'invalid': function (row, colName, colValue, rowIndex, btnName) {
                        let invalidName = '<span>未作废</span>';
                        if(Utils.isTrue(row.invalid)) {
                            invalidName = '<span class="font-red">已作废</span>';
                        }
                        return invalidName;
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let domHtml = '';
                        if(self.checkActionPerm('showCode') && !row.invalid) {
                            domHtml = domHtml + '<a name="showCode" class="swb-btn swb-btn-link">查看</a>';
                        }
                        if(self.checkActionPerm('invalid') && !row.invalid) {
                            domHtml = domHtml + '<a name="invalid" class="swb-btn swb-btn-link">作废</a>';
                        }
                        return domHtml;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if(btnName == 'invalid') {
                            self.doInivalid(row.id);
                        } else if(btnName == 'showCode') {
                            self.showDdctQrcodeInfo(row);
                        }
                    }
                });
            },
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.lastPageNumber = null;
                //
                this.getDdctQrcodeList();
            },
            //
            handleClick(tab, event) {
                this.pageNoChangeHandler(1, this.pageSize);
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getDdctQrcodeList();
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            getDdctQrcodeList(){
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoading = MsgBox.loading();
                merchtComnApi.getDdctQrcodePageList(postData, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        let bizTagList = result.data.rows;
                        //
                        self.totalCount = result.data.pagination.totalCount;
                        self.renderTable(bizTagList, result.data.pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 新增
            saveDdctQrcode: function () {
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: '新增',
                    width: 800,
                    height: 600,
                    okText: '生成二维码',
                    template: '<swb-ddct-qrcode-save ref="swb_ddct_qrcode_save"></swb-ddct-qrcode-save>',
                    data: {},
                    okClicked: function () {
                        let resultData = this.$refs.swb_ddct_qrcode_save.getDlgResult() || {};
                        if(resultData.type === 'info') {
                            let ddctqrCodeInfo = resultData.data;
                            //
                            let theLoad = MsgBox.loading();
                            merchtComnApi.saveDdctQrcode(ddctqrCodeInfo, function (result) {
                                theLoad.hide();
                                if(result.type === "info") {
                                    theDlg.close();
                                    //
                                    self.getDdctQrcodeList();
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                        } else {
                            MsgBox.warning(resultData.message);
                        }
                        return false;
                    }
                });
            },
            // 查看
            showDdctQrcodeInfo: function (row) {
                if(row.usage === 1) {    // 入职
                    let theLoading = MsgBox.loading();
//                    let postData = row;
                    // {content: row.content}
                    retailerAuthxApi.getRetailerComRoleQrCodeUrl(row, function (result) {
                        theLoading.close();
                        if(result.type == 'info') {
                            let qrCodeUrl = result.data;
                            showQrCodeImageDlg(qrCodeUrl, "入职二维码", 300, 300, {
                                headText: row.topTxt,
                                footText: row.btmTxt,
                                headHeight: 30,
                                footHeight: 28
                            });
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                } else if(row.usage === 2) {    // 离职
                    let content = {
                        type: 'staffResign',
                        theNo: row.theNo
                    };
                    showQrCodeImageDlg(JSON.encode(content), "离职二维码", 300, 300, {
                        headText: row.topTxt,
                        footText: row.btmTxt,
                        headHeight: 30,
                        footHeight: 28
                    });
                } else {
                    MsgBox.warning("请确认二维码用途");
                }
            },
            // 作废
            doInivalid: function (id) {
                let self = this;
                //弹出确认框
                this.$confirm('确定作废当前二维码吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {
                        id: id
                    };
                    let theLoad = MsgBox.loading();
                    merchtComnApi.upateDdctQrcodeForInvalid(postData, function (result) {
                        theLoad.hide();
                        if(result.type === "info") {
                            //
                            self.getDdctQrcodeList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/comn/DdctQrcodeList.vue